import { Link } from "react-router-dom";
import heroImg from "@/assets/oz-mascot-property.webp";

const HeroSection = () => (
  <>
    <section className="bg-[#FFC300] relative overflow-hidden">
      {/* Hero Content */}
      <div className="relative z-10 container">
        <div className="flex flex-col xl:flex-row xl:items-end min-h-[420px] md:min-h-[480px] xl:min-h-[520px]">
          <div className="w-full xl:w-1/2 flex flex-col justify-center items-center xl:items-start text-center xl:text-left py-10 md:py-16 xl:py-20 pr-0 xl:pr-12">
            <h1 className="text-4xl md:text-5xl xl:text-6xl font-black text-[#1a1a1a] leading-[1.08] tracking-tight">
              Property Maintenance & Upgrades Across Melbourne
            </h1>
            <p className="mt-8 text-lg md:text-xl xl:text-lg text-[#1a1a1a]/75 max-w-md font-medium leading-relaxed">
              From feature walls and fencing to security upgrades, repairs and outdoor improvements — Oz Property Services Co. helps you get quality work done without the runaround.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center xl:justify-start w-full sm:w-auto">
              <Link
                to="/get-quote"
                className="bg-[#1a1a1a] text-[#FFC300] px-8 py-4 text-lg font-bold rounded-md hover:opacity-90 transition-opacity text-center"
              >
                Get a Free Quote
              </Link>
              <Link
                to="/services"
                className="border-2 border-[#1a1a1a] text-[#1a1a1a] px-8 py-4 text-lg font-bold rounded-md hover:bg-[#1a1a1a]/5 transition-colors text-center"
              >
                View Services
              </Link>
            </div>
          </div>
          <div className="w-full xl:w-1/2 relative flex items-end justify-center xl:justify-end mt-4 xl:mt-0">
            <img
              src={heroImg}
              alt="Oz Property Services Co. kangaroo mascot with feature wall, fencing and tools"
              width="1512"
              height="1024"
              className="w-[85%] md:w-[65%] xl:w-[100%] max-w-none h-auto object-contain object-bottom xl:object-right-bottom"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Subtle diagonal divider */}
    <div className="relative -mt-1">
      <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto block" preserveAspectRatio="none">
        <polygon points="0,0 1440,50 1440,60 0,60" fill="#FFC300" />
      </svg>
    </div>
  </>
);

export default HeroSection;
